import { render } from "./UserFormGroupInput.vue?vue&type=template&id=798ba35a"
import script from "./UserFormGroupInput.vue?vue&type=script&lang=js"
export * from "./UserFormGroupInput.vue?vue&type=script&lang=js"

import "./UserFormGroupInput.vue?vue&type=style&index=0&id=798ba35a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__